import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-to-be-paid-new',
  templateUrl: './to-be-paid-new.component.html',
  styleUrls: ['./to-be-paid-new.component.css'],
})
export class ToBePaidNewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
